<p-dialog [(visible)]="display" [style]="{width: '60vw'}" [closable]="false" class="no-header"
[ngClass]="{ 'miniDialog': isMini, 'topDialog' : !isMini }" [modal]="!isMini">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-jc-between w-100 p-py-3" style="position: sticky;top: 0;background: #fff;z-index: 999;">
            <h5 class="p-mb-0">ChatBot</h5>
            <div>
                <span class="btnBars" (click)="isMini = true;onBodyAuto();" *ngIf="!isMini">
                    <i class="pi pi-window-minimize"></i>
                </span>
                <span class="btnBars" (click)="onMaximize()" *ngIf="isMini">
                    <i class="pi pi-window-maximize"></i>
                </span>
                <span class="btnBars" (click)="onCancelClick();onBodyAuto();">
                    <i class="pi pi-times"></i>
                </span>
            </div>
        </div>
    </ng-template>
    <div class="p-grid" *ngIf="!isMini">
        <div class="p-col-2">
            <p-panelMenu [model]="configMenu" [style]="{'width':'100%'}"></p-panelMenu>
        </div>
        <div class="p-col-10">
            <div #scroll class="card p-pt-0">
                <div class="chat-list"  [style.min-height]="scrHeight">
                    <ng-container *ngFor="let item of chatMessages">
                        <div class="chat-item"
                            [ngClass]="{'right' : item?.user?.id == sender.id, 'left': item?.user?.id != sender.id}">
                            <!-- <img id="avatar" [src]="item?.user?.profileImageUrl"> -->
                            <div class="ai-logo" *ngIf="item?.user?.id != sender.id">
                                <i class="pi pi-sparkles"></i>
                            </div>
                            <div class="user-logo" *ngIf="item?.user?.id == sender.id,">
                                <span>{{app?.user?.userName | nameShortener}}</span>
                            </div>
                            <div id="message-body" [ngClass]="{'leftBoxBg' : item?.user?.id == sender.id, 'rightBoxBg': item?.user?.id != sender.id}">
                                <div [ngSwitch]="item?.messageType">
                                    <ng-container *ngSwitchCase="'image'">
                                        <ng-container *ngIf="item?.image?.data && item?.image?.layout">
                                            <plotly-plot [data]="item?.image?.data" [layout]="item?.image?.layout"
                                            ></plotly-plot>
                                        </ng-container>
                                        <p style="line-height: 2; white-space: break-spaces!important;" class="p-py-3">
                                            {{item?.message}}
                                        </p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'table'">
                                        <p style="line-height: 2; white-space: break-spaces!important;" class="p-py-3">
                                            {{item?.message}}
                                        </p>
                                        <p-table
                                        #dt
                                        [value]="item?.table?.tableData"
                                        [columns]="item?.table?.columns" styleClass="p-datatable-gridlines p-mb-2"
                                        [paginator]="true"
                                        [rows]="pageSize"
                                        [totalRecords]="item?.table?.totalRecords"
                                        [responsive]="true"
                                        [showCurrentPageReport]="true"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                        >
                                        <ng-template pTemplate="caption">
                                            <div style="text-align: right">
                                                <i
                                                    class="pi pi-download"
                                                    style="cursor: pointer; font-size: 1.5em;"
                                                    (click)="dt.exportCSV()"
                                                    pTooltip="Export table data"
                                                    tooltipPosition="left"
                                                    ></i>
                                            </div>
                                        </ng-template>

                                            <ng-template pTemplate="header">
                                              <tr>
                                                <th *ngFor="let col of item?.table?.columns">{{col.header}}</th>
                                              </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-rowData>
                                              <tr>
                                                <td *ngFor="let col of item?.table?.columns">
                                                  {{rowData[col.field] !== null ? rowData[col.field] : 'N/A'}}
                                                </td>
                                              </tr>
                                            </ng-template>
                                            <ng-template pTemplate="empty">
                                                <tr>
                                                  <td colspan="{{ item?.table?.columns?.length }}" style="text-align: center;">No data available</td>
                                                </tr>
                                              </ng-template>
                                          </p-table>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'text'">
                                        <p *ngIf="!item?.messageSegments?.length" style="line-height: 2; white-space: break-spaces!important;">
                                            {{item?.message}}
                                        </p>
                                        <ng-container *ngIf="item?.messageSegments?.length > 0">
                                            <div *ngFor="let segment of item?.messageSegments; let segmentIndex = index">
                                                <!-- Render text blocks -->
                                                <ng-container *ngIf="segment.type === 'text'">
                                                    <div style="line-height: 2; white-space: break-spaces!important;">
                                                        {{ segment.content }}
                                                    </div>
                                                </ng-container>

                                                <!-- Render tables with PrimeNG p-table -->
                                                <ng-container *ngIf="segment.type === 'table'">
                                                    <p-table [value]="segment.content" [scrollable]="true" scrollHeight="300px" class="p-my-3"
                                                        [style]="{width:'100%','max-width': '600px', 'margin-bottom': '1rem' }" styleClass="p-datatable-gridlines">
                                                        <ng-template pTemplate="caption">
                                                            <div style="text-align: right">
                                                                <i class="pi pi-download" style="cursor: pointer; font-size: 1.5em;" (click)="exportToExcel(segment.headers,segment.content)" pTooltip="Export table data" tooltipPosition="left"></i>
                                                            </div>
                                                        </ng-template>
                                                        <ng-template pTemplate="header">
                                                            <tr>
                                                                <th *ngFor="let header of segment.headers">{{ header }}</th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="body" let-row>
                                                            <tr [ngClass]="{'parentRow': isTotalRow(segment.headers,row) }">
                                                                <td *ngFor="let header of segment.headers">{{ row[header] }}</td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </ng-container>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'typing'">
                                        <div class="wave">
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div id="icons" class="p-mt-2 p-d-flex" *ngIf="item?.user?.id != sender.id">
                                <span class="btnBars" (click)="copyMessageToClipboard(item)">
                                    <i style="font-size: 15px;" class="pi pi-copy"></i>
                                </span>
                                <span class="btnBars" (click)="openFeedback(true, item.queryId)">
                                    <i style="font-size: 15px;" class="fa fa-thumbs-o-up"></i>
                                </span>
                                <span class="btnBars" (click)="openFeedback(false, item.queryId)">
                                    <i style="font-size: 15px;" class="fa fa-thumbs-o-down"></i>
                                </span>
                            </div>
                            <div id="icons" class="p-mt-2 p-d-flex" *ngIf="item?.user?.id != receiver.id">
                                <span class="btnBars" (click)="reWrite(item)">
                                    <i style="font-size: 15px;" class="pi pi-refresh"></i>
                                </span>
                                <span class="btnBars" (click)="copyMessageToClipboard(item)">
                                    <i style="font-size: 15px;" class="pi pi-copy"></i>
                                </span>
                            </div>
                        </div>
                    </ng-container>
                    <div class="centered-spinner" style="margin: auto;">
                        <p-progressSpinner [style]="{width: '20px', height: '20px'}" strokeWidth="4" *ngIf="showSpinner"></p-progressSpinner>
                    </div>
                </div>
                <div class="chat-footer">
                    <span class="p-input-icon-right w-100">
                        <i *ngIf="chatInputMessage !== ''" style="font-size: 20px;margin-top: -10px;" class="fa fa-send sendIcon" (click)="send()"></i>
                        <i *ngIf="chatInputMessage === ''" style="font-size: 20px;margin-top: -10px;"
                            class="fa fa-send"></i>
                        <input type="text" class="w-100" pInputText [(ngModel)]="chatInputMessage" (keyup.enter)="send()"
                        placeholder="Ask a question about your data..." style="font-size: 13px;padding: 1rem;padding-right: 2.5rem;" />
                    </span>
                    <p-table [value]="suggestions" dataKey="id" responsiveLayout="scroll" class="suggestionTB" [expandedRowKeys]="expandedRows">
                        <ng-template pTemplate="body" let-product let-expanded="expanded">
                            <tr *ngIf="product.children.length > 0">
                                <td style="width: 1rem;padding: 0.5rem !important;">
                                    <button type="button" pButton pRipple [pRowToggler]="product"
                                    class="p-button-text p-button-rounded p-button-plain"
                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                    style="width: 1.25rem;height: 1.25rem;"></button>
                                </td>
                                <td style="padding-left: 0 !important;">{{product.name}}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="rowexpansion" let-product>
                            <ng-container *ngFor="let child of product.children">
                                <tr class="cursor-pointer" (click)="addQuestion(child)">
                                    <td colspan="2">
                                        <span class="p-mr-2 fa fa-location-arrow"></span>
                                        {{child.name}}
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</p-dialog>

<p-dialog header="Provide additional feedback" [(visible)]="displayFeedback" [modal]="true" [responsive]="true" [style]="{width: '50vw'}">
  <div class="card">
    <div class="p-grid">
        <div class="p-col-12">
            <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="feedbackText"></textarea>
        </div>
    </div>
  </div>

    <p-footer>
        <button type="button" pButton (click)="displayFeedback=false;" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="saveFeedback()"></button>
    </p-footer>
</p-dialog>

<p-dialog [(visible)]="displayChart" [modal]="true" [responsive]="true"
    [style]="{width: '90vw'}">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-jc-between w-100">
            <h5 class="p-mb-0">{{chartHeader}}</h5>
            <div class="icon-group">
                <span class="btnBars" pTooltip="Pin to Dashboard" tooltipPosition="top" (click)="savedToDashboard();">
                    <i class="fa fa-thumb-tack" style="margin-left:-5px;font-size:15px"></i>
                </span>
                <span class="btnBars" pTooltip="Send to Email" tooltipPosition="top" (click)="openEmail()">
                    <i class="pi pi-envelope"></i>
                </span>
            </div>
        </div>
    </ng-template>
    <div class="card">
      <div class="p-grid">
          <div class="p-col-12" #content>
            <ng-container *ngIf="chartType == 'image'">
                <div *ngIf="chartData && chartData?.length > 0" class="p-text-center">
                    <img [src]="chartData" [style.max-height.px]="contentHeight">
                </div>
            </ng-container>
          </div>
      </div>
    </div>

    <p-footer>
        <button type="button" pButton (click)="displayChart=false;" label="Cancel" class="p-button-secondary"></button>
        <!-- <button type="button" pButton (click)="savedToDashboard();" label="Pin to Dashboard" class="p-button-secondary"></button> -->
    </p-footer>
</p-dialog>

  <!-- <p-dialog header="Saved to Dashboard" [(visible)]="displayDashboardChannel" [modal]="true" [responsive]="true"
        [style]="{width: '50vw'}">
        <span class="p-ml-2">
            <p-dropdown placeholder="Choose Dashboard Channel" [options]="dashboardChannels" [(ngModel)]="selectedDasboardChannel" (onChange)="selectDashboardChannel()" optionLabel="name" appendTo="body" class="customDD" [baseZIndex]="0"></p-dropdown>
        </span>
        <button type="button" pButton (click)="displayChart=false;" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="savedToDashboard();" label="Save" class="p-button-secondary"></button>
    </p-dialog> -->

<p-dialog header="Pin to Dashboard" [(visible)]="displayNewLayout" [modal]="true" [closable]="true" [style]="{width: '50vw'}">
    <ng-template pTemplate="content">
            <h6 class="p-mb-2">Dashboard Layout</h6>
            <p-dropdown placeholder="Choose Dashboard Layout" [options]="dashboardChannels" [(ngModel)]="addedDashboardChannel"
                (onChange)="checkErrorMsg()" optionLabel="name" appendTo="body">
            </p-dropdown>
            <div *ngIf="channelSelectErrorMsg" class="p-invalid p-mt-2">{{ channelSelectErrorMsg }}</div>

            <h6 class="p-mb-2 p-mt-3">Widget title</h6>
            <input type="text" pInputText [(ngModel)]="savedToDashboardTitle" (change)="checkErrorMsg()"/>
            <div *ngIf="savedToDashboardTitleErrorMsg" class="p-invalid p-mt-2">{{ savedToDashboardTitleErrorMsg }}</div>

    </ng-template>
    <p-footer>
        <button type="button" pButton (click)="displayNewLayout=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="addNewDashboardLayout()" label="Save"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Send Email" [(visible)]="displayEmail" [modal]="true" [closable]="true" [style]="{width: '50vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-lg-1">
                <label>Send To </label>
            </div>
            <div class="p-lg-11">
                <span class="p-input-icon-right w-100"  [ngClass]="{ 'p-invalid': toAutocomplete.invalid && (toAutocomplete.touched || toAutocomplete.dirty) }">
                    <p-autoComplete
                        field="emailAddress"
                        [required]="true"
                        name="toRecipients"
                        id="toRecips"
                        #toADropdown
                        #toAutocomplete="ngModel"
                        [(ngModel)]="toRecipients"
                        [suggestions]="emailList"
                        [completeOnFocus]="true"
                        [ngModelOptions]="{ standalone: true }"
                        ngDefaultControl
                        [multiple]="true"
                        (completeMethod)="emailListDropdown($event.query)"
                        (onSelect)="onSelect($event.value, 'to')"
                        styleClass="w-100" appendTo="body">
                        <ng-template let-toRecip pTemplate="item">
                            <ng-container *ngIf="toRecip.name">
                                {{toRecip.name + "<" + toRecip.emailAddress +">"}}
                            </ng-container>
                        </ng-template>
                    </p-autoComplete>
                </span>
                <small *ngIf="toRecipients.length < 1 && (toAutocomplete.touched || toAutocomplete.dirty)"
                    class="p-invalid">At least one recipient
                    is
                    required</small>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayEmail=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Send" [loading]="sendMailLoading" (click)="sendSavedSearchChartEmail()"></button>
    </p-footer>
</p-dialog>

<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
